import styled from "styled-components";

export const DeploymentInstructionsContainer = styled.div`
  .download-file {
    display: flex;
    gap: 8px;
    align-items: center;
    margin-bottom: 24px;
  }

  .label-with-code-box {
    display: flex;
    flex-direction: column;
    margin-bottom: 32px;

    .code-box {
      display: flex;
      padding: 4px 12px;
      background-color: rgba(0, 0, 0, 0.08);
      border-radius: 6px;
      justify-content: space-between;
      align-items: center;
    }
  }

  .documentation-link {
    font-style: italic;
  }
`;
